import { createEntityAdapter } from '@reduxjs/toolkit';
import { IProjectExtraComponent } from 'application/project/api/ProjectExtraComponent';

export const projectExtraComponentAdapter = createEntityAdapter<IProjectExtraComponent, number>({
  selectId: (project) => project.projectExtraComponentID,
});
